/*
Copyright MITSUBISHI Elec.
*/

/**
 * ## BlenderTabBar
 *
 * BlenderGrid/BlenderCellBaseGrid をアタッチ可能な TabBar コンポーネント。
 * アタッチされたBlenderGrid/BlenderCellBaseGridのIDは以下の通り。
 *
 * ■BlenderGrid
 * 　　rbg_xxxx_yyyy (xxxx: tabbarのID, yyyy: tabのID)
 * ■BlenderCellBaseGrid
 * 　　cbg_xxxx_yyyy (xxxx: tabbarのID, yyyy: tabのID)
 * ex)
 * 　　var tabbar = new BlenderTabBar("tbb1","top");
 * 　　tabbar.setImagePath("../codebase/imgs/");
 * 　　tabbar.setSkin("blender");
 * 　　tabbar.addTab("tb1","200px");
 * 　　tabbar.addTab("tb2","200px");
 * 　　var grid1 = tabbar.cells("tb1").attachGrid(); // ID: rbg_tbb1_tb1
 * 　　var grid2 = tabbar.cells("tb2").attachCellBaseGrid(); // ID: cbg_tbb1_tb1
 *
 * @module BlenderTabBar
 * @class BlenderTabBar
 * @constractor
 * @extends [dhtmlXTabBar]
 * @param conf {object}
 * @param mode {string}
 */
function BlenderTabBar(conf,mode){
	this.tagId = (isString(conf) ? conf : conf.parent);
	this.skin = "blender";
	//スキン毎のタブの幅のオフセット値
	this.fixTabsOfs = {dhx_skyblue:1,dhx_web:0,dhx_terrace:1,material:0,blender:1,blender_radius:1,blender_jquery:1};
	if(!isString(conf)&&("fixTabsOfs" in conf)) $.extend(this.fixTabsOfs, conf.fixTabsOfs);
	if(!isString(conf)&&("skin" in conf)) this.skin = conf.skin;

	dhtmlXTabBar.call(this,conf,mode);

	//スキン毎のタブ調整幅値
	this.conf.tabsWidth["blender"] = [35,9];
	this.conf.tabsWidth["blender_radius"] = [35,9];
	this.conf.tabsWidth["blender_jquery"] = [35,9];
	if(!isString(conf)&&("tabsWidth" in conf)) $.extend(this.conf.tabsWidth, conf.tabsWidth);
	this.setSkin(this.skin);

	var that = this;

	dhtmlXCellObject.prototype.attachGrid = function() {
//		this.callEvent("_onBeforeContentAttach",["grid"]);

		var obj = document.createElement("DIV");
		obj.id = "rbg_"+that.tagId+"_"+this._idd;
//		obj.id = "dhx_cell_tabbar"+"_"+this._idd;
		obj.style.width = "100%";
		obj.style.height = "100%";
		obj.cmp = "grid";
		this._attachObject(obj);

		this.dataType = "grid";
//		this.grid = new dhtmlXGridObject(obj);
		this.grid = new BlenderGrid(obj.id);
		this.grid.setSkin(this.conf.skin);
		this.grid.entBox.style.border = "0px solid white";
		this.grid._sizeFix=0;
		this.gridId = obj.id;
		this.gridObj = obj;

//		this.callEvent("_onContentAttach",[]);

		return this.grid;
	};

	dhtmlXCellObject.prototype.attachCellBaseGrid = function() {
//		this.callEvent("_onBeforeContentAttach",["grid"]);

		var obj = document.createElement("DIV");
		obj.id = "rbg_"+that.tagId+"_"+this._idd;
//		obj.id = "dhx_cell_tabbar"+"_"+this._idd;
		obj.style.width = "100%";
		obj.style.height = "100%";
		obj.cmp = "grid";
		this._attachObject(obj);

		this.dataType = "grid";
//		this.grid = new dhtmlXGridObject(obj);
		this.grid = new BlenderCellBaseGrid(obj.id);
		this.grid.setSkin(this.conf.skin);
		this.grid.entBox.style.border = "0px solid white";
		this.grid._sizeFix=0;
		this.gridId = obj.id;
		this.gridObj = obj;

//		this.callEvent("_onContentAttach",[]);

		return this.grid;
	};

	//
	this.tabsArea.onmouseover = function(e) {
		e = e||event;
		var t = (e.target||e.srcElement);
		while (t != null) {
			if (typeof(t._tabCloseId) != "undefined") {
				if (that._onTabsAreaClick(t._tabCloseId) !== true) return;
				t = null;
			} else if (typeof(t._tabId) != "undefined") {
				if (typeof(that.conf.lastHover) != "undefined"&&that.conf.lastHover != t._tabId) {
					if (that.t[that.conf.lastHover]!=null)
						$(that.t[that.conf.lastHover].tab).removeClass("tab_hover");
				}
//				if (that.conf.lastActive != t._tabId) {
					$(that.t[t._tabId].tab).addClass("tab_hover");
					that.conf.lastHover = t._tabId;
//				}
				t = null;
			}
			if (t != null) {
				t = t.parentNode;
				if (t == this) t = null;
			}
		}
	}
	//
	this.tabsArea.onmouseout = function(e) {
		e = e||event;
		var t = (e.target||e.srcElement);
		while (t != null) {
			if (typeof(t._tabCloseId) != "undefined") {
				if (that._onTabsAreaClick(t._tabCloseId) !== true) return;
				t = null;
			} else if (typeof(t._tabId) != "undefined") {
				if (typeof(that.conf.lastHover) != "undefined"&&that.conf.lastHover != t._tabId) {
					if (that.t[that.conf.lastHover]!=null) {
						$(that.t[that.conf.lastHover].tab).removeClass("tab_hover");
						that.conf.lastHover = "";
					}
				}
				t = null;
			}
			if (t != null) {
				t = t.parentNode;
				if (t == this) t = null;
			}
		}
	}

};


// Extends
BlenderTabBar.inherit(dhtmlXTabBar);

/*
 * スキン毎のタブの幅のオフセット値を取得する。
 * 新たなスキンを設定する場合は、
 * @method _fixTabOfs スキン毎のタブの幅のオフセット値
 * @private
 */
BlenderTabBar.prototype._fixTabsOfs = function() {
	this.conf.tabsOfs = this.fixTabsOfs[this.conf.skin];
};

/*
Copyright MITSUBISHI Elec.
*/
